import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const FormInput = ({ name, formData, placeholder, changeInputHandle }) => {
    const [text, setText] = useState(formData?.[name] || '');
    const numberTypeList = ['age', 'id_number'];
    const changeHandle = (event) => {
        const eventValue = event.target.value;

        setText(eventValue);
        changeInputHandle(name, eventValue);
    };
    const inputType = numberTypeList.includes(name) ? 'nubmer' : 'text';

    return (
        <div className={styles.formInputBox}>
            <input
                placeholder={placeholder || ''}
                className={styles.formInput}
                onChange={changeHandle}
                type={inputType}
                value={text || formData?.[name] || ''}
            />
        </div>
    );
};

FormInput.propTypes = {
    name: PropTypes.string,
    formData: PropTypes.object,
    placeholder: PropTypes.string,
    changeInputHandle: PropTypes.func,
};

export default errorBoundary(FormInput);
